import React from "react"
import { ReactComponent as BarsIcon } from "../../design/assests/images/icons/bars.svg"

export default function HamburgerMenuIcon({ activateSidebar }) {
  return (
    <BarsIcon
      className={"hamburger-menu-icon"}
      onClick={() => {
        activateSidebar()
      }}
    />
  )
}
